import { cartV2 } from '@wix/ecom';

export class CatalogReferenceModel {
  public catalogItemId?: string;
  public appId?: string;
  public options?: Record<string, unknown> | null;

  constructor(catalogReferenceModel: CatalogReferenceModel) {
    this.catalogItemId = catalogReferenceModel.catalogItemId;
    this.appId = catalogReferenceModel.appId;
    this.options = catalogReferenceModel.options;
  }

  public static fromV2(catalogReference?: cartV2.CatalogReference) {
    if (!catalogReference) {
      return undefined;
    }
    return new CatalogReferenceModel({
      catalogItemId: catalogReference.catalogItemId,
      appId: catalogReference.appId,
      options: catalogReference.options,
    });
  }
}
